/*
 * @Author: 朱占为
 * @LastEditors: liyuntao
 * @description: page description
 * @Date: 2021-07-16 18:39:27
 * @LastEditTime: 2022-06-30 12:21:35
 */

import { Grid,GridItem,Popup,List, Cell, CellGroup, Search, Button, Steps, Step, Tabbar, TabbarItem, Icon, NavBar, Empty, Tab, Tabs,
  IndexBar, IndexAnchor, Progress, ActionSheet, Collapse,Card, CollapseItem,Field,RadioGroup, Radio,Dialog,
  Loading,SwipeCell,SubmitBar,Popover,Form,Checkbox,CheckboxGroup,Notify,Picker ,Calendar,Overlay,Pagination,Tag,PullRefresh,NoticeBar,Rate,Stepper } from 'vant';
import VXETable from 'vxe-table';
export default function(app) {
  app.use(Grid);
  app.use(GridItem);
  app.use(Button);
  app.use(Search);
  app.use(Steps);
  app.use(Step);
  app.use(Tabbar);
  app.use(TabbarItem);
  app.use(Icon);
  app.use(NavBar);
  app.use(Empty);
  app.use(Tab);
  app.use(Tabs);
  app.use(IndexBar);
  app.use(IndexAnchor);
  app.use(Cell);
  app.use(CellGroup);
  app.use(List);
  app.use(Popup);
  app.use(Progress);
  app.use(ActionSheet);
  app.use(Collapse);
  app.use(CollapseItem);
  app.use(Field);
  app.use(Radio);
  app.use(RadioGroup);
  app.use(Dialog);
  app.use(Loading);
  app.use(SwipeCell);
  app.use(SubmitBar);
  app.use(Card);
  app.use(Checkbox);
  app.use(CheckboxGroup)
  app.use(Popover)
  app.use(Form)
  app.use(Notify)
  app.use(Picker)
  app.use(Calendar)
  app.use(Overlay)
  app.use(Pagination)
  app.use(Tag)
  app.use(PullRefresh)
  app.use(NoticeBar )
  app.use(Rate )
  app.use(Stepper)
  app.use(VXETable);
  app.provide('$dialog', Dialog);
  app.provide('$notify', Notify);
}
